<template>
  <BranchPostIndexReport
      :items="items"
      :pfilters="this.$route.params.filters"
      :area-id="Number(this.$route.params.areaId)"
      @updated="onUpdate"
  />
</template>

<script>
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import ReportService from "@/services/report.service"
import _ from "underscore"
import Mapper from "@/mappers"
import Moment from "moment";
import {AllowStatistics} from "@/enums/permission";
import BranchPostIndexReport from "@/components/report/BranchStatistics/BranchPostIndexReportComponent.vue";

export default {
  name: "BranchPostIndexReportView",
  components: {
    BranchPostIndexReport
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    isAllowStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowStatistics
      })
    }
  },
  methods: {
    onUpdate(filters) {
      const {start, end, date, selectedFilters, selectedPostIndexes, isAllClientsSelected, isArchive, clients} = filters;
      if (selectedFilters && selectedFilters.includes(3) && !selectedFilters.includes(2)) {
        selectedFilters.push(2);
      }

      const areaId = this.$route.params.areaId;
      const regionId = this.$route.params.regionId;
      this.$store.dispatch(LAYOUT_LOADING_START)
      ReportService.getBranchPostIndexReport({
        client: this.$store.getters.appActiveClient,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
        regionId : regionId,
        areaId : areaId,
        date: date ? Moment(date, "YYYY-MM") : null,
        selectedFilters: selectedFilters ? selectedFilters : null,
        selectedPostIndexes: selectedPostIndexes ? selectedPostIndexes : null,
        isAllClientsSelected: isAllClientsSelected,
        type: isArchive,
        clients: clients
      })
          .then(response => {
            this.items = _.map(response.data, rvm => {
              return {
                postIndex: Mapper.mapPostIndex(rvm.PostIndex),
                received: rvm.Received,
                printedForPeriodNormal: rvm.PrintedForPeriodNormal,
                restForPeriodEnd: selectedFilters ?
                    (rvm.Received !== null && rvm.PrintedForPeriodNormal !== null ?
                        (rvm.Received - rvm.PrintedForPeriodNormal) : null) : null,
                deletedFromPostPackageCount: rvm.DeletedFromPostPackageCount,
                postPackedForPeriod: rvm.PostPackedForPeriod,
                deliveredFromPacked: rvm.DeliveredFromPacked,
                returnedFromPacked: rvm.ReturnedFromPacked,
                postPackedNotPerformed: rvm.PostPackedNotPerformed,
                tryPerform: rvm.TryPerformCount,
                expiredCount: rvm.ExpiredCount,
                successDeliveredAfterFailedCount: rvm.SuccessDeliveredAfterFailedCount
              }
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowStatistics) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Статистика филиалов по пост олделениям")
    }
    else
      this.$router.go(-1)
  }
}
</script>

<style scoped>
</style>
